'use client';
import { useViewport } from '@lib/tools/hooks/useViewport';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import style from './RedPriceTooltip.module.scss';

export const RedPriceTooltip = ({ text, children, someStyles }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const pathname = usePathname();

  const { isMobile } = useViewport();

  const setHover = () => {
    if (isMobile && pathname.includes('/list')) {
      return undefined;
    }

    setShowTooltip(prevState => !prevState);

    return undefined;
  };

  return (
    <div className={style.tooltipBox} onMouseEnter={setHover} onMouseLeave={setHover}>
      {children}
      {showTooltip && (
        <div className={classNames(style.wrapper, someStyles)}>
          <div className={style.tooltipContent}>
            <div className={style.tooltip}>
              <span>{text}</span>
            </div>
            <div className={style.topSquare} />
            <div className={style.bottomSquare} />
          </div>
        </div>
      )}
    </div>
  );
};
